import VueRouter from "vue-router";
import Index from '../pages/index.vue'
import Map from '../pages/map.vue'
import MapTest from '../pages/maptest.vue'
import Vue from 'vue'
Vue.use(VueRouter)
const router = new VueRouter({
    routes:[
        {
            path:"/",
            component:Map
        },
        {
            path:"/index",
            component:Index
        },
		{
		    path:"/map",
		    component:Map
		},
		{
		    path:"/maptest",
		    component:MapTest
		}
    ]
})

export default router